import { Box, Drawer } from "@mui/material";
import { MenuIndex } from "../../model/mainMenuIndex";
import { NavBar } from "./components/NavBar";
import { SectionButton } from "../IndexDrawer/components/SectionButton";
import { SubSectionButton } from "../IndexDrawer/components/SubSectionButton";
import { Divider } from "./components/Divider";
import { AccordionSection } from "./components/AccordionSection";
import { list } from "../../setting";
import _ from "lodash";
import muiTheme from "../../themes/muiTheme";

interface Props {
  pageWidth: number;
  currentPage: number;
  isOpen: boolean;
  isPortrait: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setExpanded: React.Dispatch<React.SetStateAction<string | false>>;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const IndexDrawer = ({
  currentPage,
  pageWidth,
  isOpen,
  isPortrait,
  setPage,
  setExpanded,
  setIsDrawerOpen,
}: Props) => {
  return (
    <Drawer
      sx={{
        width: 0,
        flexShrink: 0,
        alignItems: "start",
        justifyContent: "start",
        "& .MuiDrawer-paper": {
          width: !isPortrait ? 240 : "100%",
          alignItems: !isPortrait ? "start" : "center",
          borderTopLeftRadius: !isPortrait ? 8 : 0,
          height: "100%",
          border: 0,
          paddingTop: 5.2,
          boxShadow: 1,
          overflowX: "hidden",
          overflowY: "auto",
          bgcolor: "white",
          zIndex: 2,
        },
        borderTopLeftRadius: 100,
      }}
      variant="persistent"
      ModalProps={{ disableRestoreFocus: true }}
      anchor="right"
      open={isOpen}
    >
      <NavBar
        windowWidth={pageWidth}
        isOpen={isOpen}
        isPortrait={isPortrait}
        setIsOpenDrawer={setIsDrawerOpen}
      />
      {renderChildren(
        pageWidth,
        currentPage,
        list,
        isOpen,
        isPortrait,
        setPage,
        setIsDrawerOpen,
        setExpanded
      )}
    </Drawer>
  );
};

const renderChildren = (
  pageWidth: number,
  currentPage: number,
  idx: MenuIndex[],
  isOpen: boolean,
  isPortrait: boolean,
  setPage: React.Dispatch<React.SetStateAction<number>>,
  closeDrawer: React.Dispatch<React.SetStateAction<boolean>>,
  setExpanded: React.Dispatch<React.SetStateAction<string | false>>
) => {
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        paddingTop: 1.6,
        paddingBottom: 16.8,
      }}
    >
      {idx.map((e) => {
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: !isPortrait ? "center" : "start",
              width: !isPortrait ? 208 : "100%",
              px: 1.6,
              bgcolor: "white",
            }}
          >
            <SectionButton
              currentPage={currentPage}
              sectionPage={e.page}
              title={e.title}
              viewWidth={pageWidth}
              isPortrait={isPortrait}
              setPage={setPage}
              isOpen={isOpen}
              closeDrawer={closeDrawer}
            />

            {e.subList?.map((sub) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {sub.subList === undefined ? (
                  <SubSectionButton
                    currentPage={currentPage}
                    sectionPage={sub.page}
                    title={sub.title}
                    viewWidth={pageWidth}
                    setPage={setPage}
                    isOpen={isOpen}
                    isPortrait={isPortrait}
                    closeDrawer={closeDrawer}
                  />
                ) : (
                  <AccordionSection
                    sub={sub}
                    currentPage={currentPage}
                    isPortrait={isPortrait}
                    viewWidth={pageWidth}
                    setPage={setPage}
                    isOpen={isOpen}
                    closeDrawer={closeDrawer}
                  />
                )}
              </Box>
            ))}
            {e.title !== "Doctors Care" && (
              <Divider isPortrait={isPortrait} viewWidth={pageWidth} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};
